import { Divider } from '@droplet-tech-code/core-elements/module/ui/Divider/Divider';
import { VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { SupportRequestBackendClient } from '@naus-code/naus-admin-types';
import { LinkText } from '~/components/LinkText';
import { translate } from '~/utils/translation.utils';
import { getProvisionalOptionsFromSR } from '../utils/SupportRequestData';
import { bookingApi } from '~/screens/Support/Bookings/Bookings.api';
import { supportRequestActionsApi } from '~/screens/Support/Requests/supportRequestActions.api';
import { handleResponse } from '@droplet-tech-code/core-elements/module/utils/error';
import { useModalVerify } from '@droplet-tech-code/core-elements/module/ui/Modal';

export const ProvisionalRequestOptions = ({
  supportRequestInfo,
  check,
}: {
  supportRequestInfo: SupportRequestBackendClient;
  check: string;
}) => {
  const provisionalOptions = getProvisionalOptionsFromSR(supportRequestInfo);
  const { verifyAction } = useModalVerify();

  const booking = bookingApi.useGetBookingQuery(supportRequestInfo.bookingId || '', {
    skip: !supportRequestInfo.bookingId || !provisionalOptions,
  });

  const [cancelProvisionalBooking, { isLoading: isCancelling }] =
    supportRequestActionsApi.useCancelProvisionalBookingMutation();

  const [confirmProvisionalBooking, { isLoading: isConfirming }] =
    supportRequestActionsApi.useConfirmProvisionalBookingMutation();

  if (!provisionalOptions || !booking.data?.booking.hasPending) {
    return null;
  }
  const isActionInProgress = isCancelling || isConfirming;

  return (
    <VStack space="2.5" px="3">
      <VStack
        flex={1}
        space="2"
        align="center"
        bg="error-extraLight"
        p="2.5"
        b={1}
        bc="error-light"
        br={8}
      >
        <LinkText
          textStyle={{ fontSize: 15, color: 'red' }}
          isLoading={isActionInProgress}
          onPress={async () => {
            verifyAction({
              title: translate('supportRequests.provisionalBooking.cancelBooking'),
              description: translate(
                'supportRequests.provisionalBooking.cancelBookingDescription',
              ),
            }).then(async (res) => {
              if (res) {
                await cancelProvisionalBooking({
                  check,
                  supportId: supportRequestInfo._id,
                }).then((response) => {
                  handleResponse({
                    response,
                  });
                });
              }
            });
          }}
        >
          {translate('supportRequests.provisionalBooking.cancelRequest')}
        </LinkText>
      </VStack>
      <VStack
        flex={1}
        space="2"
        align="center"
        bg="success-extraLight"
        p="2.5"
        b={1}
        bc="success-light"
        br={8}
      >
        <LinkText
          textStyle={{ fontSize: 15, color: 'green' }}
          isLoading={isActionInProgress}
          onPress={async () => {
            verifyAction({
              title: translate('supportRequests.provisionalBooking.confirmBooking'),
              description: translate(
                'supportRequests.provisionalBooking.confirmBookingDescription',
              ),
            }).then(async (res) => {
              if (res) {
                await confirmProvisionalBooking({
                  check,
                  supportId: supportRequestInfo._id,
                }).then((response) => {
                  handleResponse({
                    response,
                  });
                });
              }
            });
          }}
        >
          {translate('supportRequests.provisionalBooking.confirmRequest')}
        </LinkText>
      </VStack>
      <Divider />
    </VStack>
  );
};
